import PropTypes from 'prop-types'
import React, { Component } from 'react'

import InfoTooltip from '../../dumb/InfoTooltip'

class BuyCartRow extends Component {
  render() {
    const rowCss = `row ${this.props.extraCss}`
    return (
      <div className={rowCss}>
        <div className="left">
          <span>
            {this.props.label}
            {this.props.labelTooltip ? (
              <InfoTooltip>{this.props.labelTooltip}</InfoTooltip>
            ) : null}
          </span>
          {this.props.children}
        </div>
        {this.props.hideRight ? null : (
          <div className="right">{this.props.pricePromozione}</div>
        )}
      </div>
    )
  }
}

BuyCartRow.defaultProps = {
  extraCss: '',
  labelTooltip: '',
  hideRight: false,
}

BuyCartRow.propTypes = {
  label: PropTypes.oneOf([
    PropTypes.string.isRequired,
    PropTypes.node.isRequired,
  ]),
  labelTooltip: PropTypes.string,
  pricePromozione: PropTypes.element,
  children: PropTypes.element,
  extraCss: PropTypes.string,
  hideRight: PropTypes.bool,
}

export default BuyCartRow
